import React, { FC, useContext, useEffect, useState } from "react";
import { getIcon } from "../Shared/Util";
import { IRecord, ITableActions } from "../Interfaces/TableInterface";

interface IProps {
    defaultAction: ITableActions
}

const DefaultActionDisplay: FC<IProps> = ({ defaultAction }) => {

    const [defaultActionText, setDefaultActionText] = useState<string>("");

    useEffect(() => {
        let defaultText = getDefaultActionText(defaultAction);
        setDefaultActionText(defaultText);

    }, [defaultAction]);


    const getDefaultActionText = (action: ITableActions): string => {
        // switch statement to determine the text based on the action
        switch (action) {
            case ITableActions.View:
                return "The link will view the record";
            case ITableActions.Edit:
                return "The link will edit the record ";
            case ITableActions.Download:
                return "The link will download the record";
            case ITableActions.DownloadPDF:
                return "The link will download a PDF rendition of the record";
            case ITableActions.DisplayPDF:
                return "The link will display a PDF rendition of the record";
            default:
                return "";
        }
    }

    return <div className="meta" style={{ marginBottom: 10 }}>{defaultActionText}</div>;
}

export default DefaultActionDisplay;